module.exports = __webpack_public_path__ + "img/buku harapan.1f738533.jpg";